
/**
 * A slide inside a `BaseSlider` component.
 */
export default {}
